import React from 'react'

import {
    ActionButton,
    ActionButtonIcon,
    CheckboxRow,
    ErrorBox,
    FormActions,
    FormField,
    FormGrid,
    FormHeader,
    FormSelect,
    FormSubtitle,
    FormTitle,
    NoticeBox,
    Panel,
} from '../../style'
import { useHistoryExportForm } from './useHistoryExportForm'

const HistoryExportForm = () => {
    const {
        groups,
        selectedGroupId,
        saveOnServer,
        exporting,
        generating,
        error,
        notice,
        setSaveOnServer,
        handleGroupChange,
        handleExport,
        handleGenerate,
    } = useHistoryExportForm()

    return (
        <Panel>
            <FormHeader>
                <div>
                    <FormTitle>Экспорт расписания</FormTitle>
                    <FormSubtitle>
                        Выберите группу и настройте параметры выгрузки
                    </FormSubtitle>
                </div>
            </FormHeader>

            <FormGrid>
                <FormField>
                    <span>Группа</span>
                    <FormSelect
                        value={selectedGroupId}
                        onChange={(event) => handleGroupChange(event.target.value)}
                    >
                        <option value="">Выберите группу</option>
                        {groups.map((group, index) => (
                            <option
                                key={group.group_id || group.id || index}
                                value={group.group_id || group.id || ''}
                            >
                                {group.name}
                            </option>
                        ))}
                    </FormSelect>
                </FormField>

                <FormField>
                    <span>Дополнительно</span>
                    <CheckboxRow>
                        <input
                            type="checkbox"
                            checked={saveOnServer}
                            onChange={(event) => setSaveOnServer(event.target.checked)}
                        />
                        <span>Сохранить файл на сервере</span>
                    </CheckboxRow>
                </FormField>
            </FormGrid>

            {error && <ErrorBox>{error}</ErrorBox>}
            {notice && <NoticeBox>{notice}</NoticeBox>}

            <FormActions>
                <ActionButton type="button" onClick={handleExport} disabled={exporting}>
                    <ActionButtonIcon>⬇</ActionButtonIcon>
                    {exporting
                        ? saveOnServer
                            ? 'Сохранение...'
                            : 'Экспорт...'
                        : saveOnServer
                            ? 'Сохранить на сервере'
                            : 'Экспортировать'}
                </ActionButton>

                <ActionButton type="button" onClick={handleGenerate} disabled={generating}>
                    <ActionButtonIcon>⚙</ActionButtonIcon>
                    {generating ? 'Генерация...' : 'Сгенерировать'}
                </ActionButton>
            </FormActions>
        </Panel>
    )
}

export default HistoryExportForm
